import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
// import LayoutConfiguracion from "../../components/layout-configuracion";
import ListarCategorias from "./gestionar-categoria/listar-categorias";
import AdministracionIndex from ".";
import ListarProductos from "./gestionar-producto/listar-productos";
import Producto from "./gestionar-producto/producto";
// import ListarVendedores from "./gestionar-vendedores/listar-vendedores";
import ListarConductores from "./gestionar-conductores/listar-conductores";
import Conductor from "./gestionar-conductores/conductor";
import ListarTipoVehiculo from "./gestionar-tipo-vehiculo/listar-tipo-vehiculo";
import ListarRolesUsuarioMovil from "./gestionar-rol/listar-roles";
import ListarUsuarioMovil from "./gestionar-usuario-movil/listar-usuario-movil";
import UsuarioMovil from "./gestionar-usuario-movil/usuario-movil";
import Empresa from "./gestionar-empresa/empresa";
import ConfiguracionVendedores from "./gestionar-vendedores/configuracion-vendedores";
import ListarPaisPage from "./gestionar-pais/listar-pais";
import PaisPage from "./gestionar-pais/pais";
import ListarCiudadesPage from "./gestionar-ciudades/listar-ciudades";
import CiudadesPage from "./gestionar-ciudades/ciudades";
import ListarVendedorPage from "./gestionar-vendedores/listar-vendedor";
import VendedorPage from "./gestionar-vendedores/vendedor";
import ListarEstadoPage from "./gestionar-estado/listar-estado";
import EstadoPage from "./gestionar-estado/estado";
import ListarSubEstadoPage from "./gestionar-sub-estado/listar-sub-estado";
import SubEstadoPage from "./gestionar-sub-estado/sub-estado";
import ListarEstadoPagoPage from "./gestionar-estado-pago/listar-estado-pago";
import EstadoPagoPage from "./gestionar-estado-pago/estado-pago";
import ListarQuienRecibeEntregaPage from "./gestionar-quien-recibe-entrega/listar-quien-recibe-entrega";
import QuienRecibeEntregaPage from "./gestionar-quien-recibe-entrega/quien-recibe-entrega";
import ListarFormularioEntregaPage from "./gestionar-formulario-entrega/listar-formulario-entrega";
import FormularioEntregaPage from "./gestionar-formulario-entrega/formulario-entrega";
import ListarGrupoGeocercaPage from "./gestionar-grupo-geocerca/listar-grupo-geocerca";
import GrupoGeocercaPage from "./gestionar-grupo-geocerca/grupo-geocerca";
import ListarProgressBarPage from "./gestionar-progress-bar/listar-progress-bar";
import ProgressBarPage from "./gestionar-progress-bar/progress-bar";
import ListarPersonasPage from "./gestionar-persona/listar-personas";
import PersonaPage from "./gestionar-persona/persona";
import ListarEstadoVehiculoPage from "./gestionar-estado-vehiculo/listar-estado-vehiculo";
import EstadoVehiculoPage from "./gestionar-estado-vehiculo/estado-vehiculo";
import ListarEjesVehiculoPage from "./gestionar-ejes-estado-vehiculo/listar-estado-ejes-vehiculo";
import EjesVehiculoPage from "./gestionar-ejes-estado-vehiculo/ejes-vehiculo";
import ListarTipoChoferPage from "./gestionar-tipo-chofer/listar-tipo-chofer";
import TipoChoferPage from "./gestionar-tipo-chofer/tipo-chofer";
import ListarPrioridadEntregaPage from "./gestionar-prioridad-entrega/listar-prioridad-entrega";
import PrioridadEntregaPage from "./gestionar-prioridad-entrega/prioridad-entrega";

const RouterAdministracion = () => {
  const { path } = useRouteMatch();
  // console.log('routerAdministracion');
  // console.log(path);
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}/listar-categorias`}>
        <ListarCategorias />
      </Route>

      <Route exact path={`${path}/listar-productos`}>
        <ListarProductos />
      </Route>
      <Route exact path={`${path}/producto`}>
        <Producto />
      </Route>

      <Route exact path={`${path}/listar-persona`}>
        <ListarPersonasPage />
      </Route>
      <Route exact path={`${path}/persona`}>
        <PersonaPage />
      </Route>

      <Route exact path={`${path}/listar-pais`}>
        <ListarPaisPage />
      </Route>
      <Route exact path={`${path}/pais`}>
        <PaisPage />
      </Route>

      <Route exact path={`${path}/listar-progress-bar`}>
        <ListarProgressBarPage />
      </Route>
      <Route exact path={`${path}/progress-bar`}>
        <ProgressBarPage />
      </Route>


      <Route exact path={`${path}/listar-ciudades`}>
        <ListarCiudadesPage />
      </Route>
      <Route exact path={`${path}/ciudad`}>
        <CiudadesPage />
      </Route>

      <Route exact path={`${path}/listar-vendedores`}>
        <ListarVendedorPage />
      </Route>
      <Route exact path={`${path}/vendedor`}>
        <VendedorPage />
      </Route>

      <Route exact path={`${path}/listar-estado`}>
        <ListarEstadoPage />
      </Route>
      <Route exact path={`${path}/estado`}>
        <EstadoPage />
      </Route>

      <Route exact path={`${path}/listar-sub-estado`}>
        <ListarSubEstadoPage />
      </Route>
      <Route exact path={`${path}/sub-estado`}>
        <SubEstadoPage />
      </Route>

      <Route exact path={`${path}/listar-estado-pago`}>
        <ListarEstadoPagoPage />
      </Route>
      <Route exact path={`${path}/estado-pago`}>
        <EstadoPagoPage />
      </Route>

      <Route exact path={`${path}/listar-quien-recibe-entrega`}>
        <ListarQuienRecibeEntregaPage />
      </Route>
      <Route exact path={`${path}/quien-recibe-entrega`}>
        <QuienRecibeEntregaPage />
      </Route>

      <Route exact path={`${path}/listar-formulario`}>
        <ListarFormularioEntregaPage />
      </Route>
      <Route exact path={`${path}/formulario`}>
        <FormularioEntregaPage />
      </Route>

      <Route exact path={`${path}/gestionar-vendedores/configuracion-vendedores`}>
        <ConfiguracionVendedores />
      </Route>

      <Route exact path={`${path}/gestionar-conductores/listar-conductores`}>
        <ListarConductores />
      </Route>
      <Route exact path={`${path}/gestionar-conductores/conductor`}>
        <Conductor />
      </Route>

      <Route exact path={`${path}/gestionar-tipo-vehiculo/listar-tipo-vehiculo`}>
        <ListarTipoVehiculo />
      </Route>

      <Route exact path={`${path}/gestionar-rol/listar-roles`}>
        <ListarRolesUsuarioMovil />
      </Route>

      <Route exact path={`${path}/gestionar-usuario-movil/listar-usuario-movil`}>
        <ListarUsuarioMovil />
      </Route>
      <Route exact path={`${path}/gestionar-usuario-movil/usuario-movil`}>
        <UsuarioMovil />
      </Route>

      <Route exact path={`${path}/gestionar-empresa/empresa`}>
        <Empresa />
      </Route>

      <Route exact path={`${path}/listar-grupo-geocerca`}>
        <ListarGrupoGeocercaPage />
      </Route>
      <Route exact path={`${path}/grupo-geocerca`}>
        <GrupoGeocercaPage />
      </Route>

      <Route exact path={`${path}/listar-estado-vehiculo`}>
        <ListarEstadoVehiculoPage />
      </Route>
      <Route exact path={`${path}/estado-vehiculo`}>
        <EstadoVehiculoPage />
      </Route>

      <Route exact path={`${path}/listar-ejes-vehiculo`}>
        <ListarEjesVehiculoPage />
      </Route>
      <Route exact path={`${path}/ejes-vehiculo`}>
        <EjesVehiculoPage />
      </Route>

      <Route exact path={`${path}/listar-tipo-chofer`}>
        <ListarTipoChoferPage />
      </Route>
      <Route exact path={`${path}/tipo-chofer`}>
        <TipoChoferPage />
      </Route>

      <Route exact path={`${path}/listar-prioridad-entrega`}>
        <ListarPrioridadEntregaPage />
      </Route>
      <Route exact path={`${path}/prioridad-entrega`}>
        <PrioridadEntregaPage />
      </Route>

      <Route exact path={`${path}`}>
        <AdministracionIndex />
      </Route>

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterAdministracion;
